/**
 * Lightweight chunk error handler following industry best practices
 * Relies on Vite's default chunking and React's Suspense/ErrorBoundary
 */
export function setupChunkErrorHandler(): void {
  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason;
    
    // Only handle actual chunk loading errors (Vite's dynamic import failures)
    if (
      error?.message?.includes('Failed to fetch dynamically imported module') ||
      error?.message?.includes('Importing a module script failed')
    ) {
      console.error('🚨 Chunk loading failed:', error);
      event.preventDefault();
      
      // Ask user to reload (don't auto-reload - respect user control)
      if (confirm('Some application resources failed to load. Would you like to reload the page?')) {
        window.location.reload();
      }
    }
  });
}
